module.exports = __webpack_public_path__ + "static/media/login-bg.5aeda870.png";